import twMerge from "../lib/twMerge";

export default function Box({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <div
      className={twMerge(
        "rounded-[8px] border bg-white shadow-[0_1px_6px_0_rgba(0,0,0,0.04)]",
        className
      )}
    >
      {children}
    </div>
  );
}
